<template>
  <div class='text_box'>
    <div>
        <h2>修改日期：2020 年 12 月 20 日</h2>
    </div>
    <div>
        <h2>生效日期：2020 年 12 月 20 日</h2>
    </div>
    <div>您在使用“ <span class="name">{{ name }}</span> ”提供的各项服务之前，应仔细阅读本用户协议。<strong>请特别注意以粗体方式标明的条款，例如对用户的权利限制的条款，约定争议解决方式、司法管辖、法律适用的条款。</strong>如您不同意本用户协议或随时对其的修改，您可以主动取消“ <span class="name">{{ name }}</span> ”提供的服务；您一旦使用“ <span class="name">{{ name }}</span> ”的服务，即视为您已了解并完全同意本用户注册协议各项内容。
    </div>
    <div>
    	<h2>一、总则</h2>
        <ul>
            <li>1.为获得“ <span class="name">{{ name }}</span> ”提供基于互联网的相关服务，服务使用人(以下称“用户”)必须同意本协议的全部条款并按照页面上的提示完成注册程序。如果用户在注册程序过程中勾选“我已经阅读并同意注册协议”一项或类似选项即表示用户与“ <span class="name">{{ name }}</span> ”达成协议，完全接受本协议项下的全部条款。</li>
            <li>2.用户可以使用“ <span class="name">{{ name }}</span> ”各个频道单项服务，当用户使用“ <span class="name">{{ name }}</span> ”各单项服务时，用户的使用行为视为其对该单项服务的服务条款以及“ <span class="name">{{ name }}</span> ”在该单项服务中发出的各类公告的同意。</li>
            <li>3.<strong>“ <span class="name">{{ name }}</span> ”用户协议以及各个频道单项服务条款和公告可由随时更新，且无需另行通知。</strong>您在使用相关服务时，应关注并遵守其所适用的相关条款。</li>
        </ul>
    </div>
    <div>
    	<h2>二、服务内容</h2>
        <ul>
            <li>1.“ <span class="name">{{ name }}</span> ”服务的具体内容由所属公司根据实际情况提供，例如相册、日记、视频、音乐等。<strong>“ <span class="name">{{ name }}</span> ”保留随时变更、中断或终止部分或全部网络服务包括收费网络服务的权利。</strong></li>
            <li>2.“ <span class="name">{{ name }}</span> ”的用户为使用“ <span class="name">{{ name }}</span> ”提供的收费服务而自行购买的VIP、虚拟道具、虚拟货币(如游戏币等)，一旦购入，<strong>除法律规定的不可抗力事件发生外，一律不可退或换成人民币或其他任何货币。</strong></li>
            <li>3.用户必须同意接受“ <span class="name">{{ name }}</span> ”通过电子邮件或其他方式向用户发送广告或其他相关商业信息。<li>
            <li>4.“ <span class="name">{{ name }}</span> ”仅提供相关的网络服务，除此之外与相关网络服务有关的设备(如电脑、调制解调器及其他与接入互联网有关的装置)及所需的费用(如为接入互联网而支付的电话费及上网费)均应由用户自行负担。</li>
        </ul>
     </div>
    <div>
    	<h2>三、使用规则</h2>
        <ul>
            <li>1.用户在申请使用“ <span class="name">{{ name }}</span> ”服务时，必须向“ <span class="name">{{ name }}</span> ”提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽及准确的要求。如果因注册信息不真实而引起的问题，并对问题发生所带来的后果，“ <span class="name">{{ name }}</span> ”不负任何责任。</li>
            <li>2.用户注册成功后，“ <span class="name">{{ name }}</span> ”将给予每个用户一个用户帐号及相应密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。<strong>帐号的所有权归“ <span class="name">{{ name }}</span> ”，用户完成申请注册手续后，获得“ <span class="name">{{ name }}</span> ”帐号的使用权。帐号使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。</strong>如果“ <span class="name">{{ name }}</span> ”发现使用者并非帐号初始注册人，“ <span class="name">{{ name }}</span> ”有权在未经通知的情况下回收该帐号而无需向该帐号使用人承担法律责任，由此带来的包括并不限于用户通讯中断、用户资料和游戏道具等清空等损失由用户自行承担。“ <span class="name">{{ name }}</span> ”禁止用户私下有偿或无偿转让帐号，以免因帐号问题产生纠纷，用户应当自行承担因违反此要求而遭致的任何损失，同时“ <span class="name">{{ name }}</span> ”保留追究上述行为人法律责任的权利。</li>
			<li>3.	用户在使用“ <span class="name">{{ name }}</span> ”服务过程中，必须遵循以下原则：
                <ul>
                    <li>a.遵守中华人民共和国相关法律法规，包括但不限于《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《最高人民法院关于审理涉及计算机网络著作权纠纷案件适用法律若干问题的解释(法释[2004]1号)》、《全国人大常委会关于维护互联网安全的决定》、《互联网电子公告服务管理规定》、《互联网新闻信息服务管理规定》、《互联网著作权行政保护办法》和《信息网络传播权保护条例》等有关计算机互联网规定和知识产权的法律和法规、实施办法；</li>
                    <li>b.“ <span class="name">{{ name }}</span> ”的所有用户不得在“ <span class="name">{{ name }}</span> ”任何板块发布、登载、转载或以其它任何方式发送任何含有下列内容之一的信息：：
                        <ul>
                            <li>(1)违反宪法确定的基本原则的；</li>
                            <li>(2)危害国家安全，泄漏国家机密，颠覆国家政权，破坏国家统一的；</li>
                            <li>(3)损害国家荣誉和利益的；</li>
                            <li>(4)煽动民族仇恨、民族歧视，破坏民族团结的；</li>
                            <li>(5)破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
                            <li>(6)散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
                            <li>(7)散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</li>
                            <li>(8)侮辱或者诽谤他人,侵害他人合法权益的；</li>
                            <li>(9)煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</li>
                            <li>(10)以非法民间组织名义活动的；</li>
                            <li>(11)含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、或其它道德上令人反感的内容；</li>
                            <li>(12)含有法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其他内容的。</li>
                        </ul>
                    </li>
                    <li>c.<strong>用户承诺对其上传或者发表于“ <span class="name">{{ name }}</span> ”的所有信息（即属于《中华人民共和国著作权法》规定的作品，包括但不限于文字、图片、音乐、电影、表演和录音录像制品和电脑程序等）均享有完整的知识产权，或者已经得到相关权利人的合法授权；</strong>如用户违反本条规定造成“ <span class="name">{{ name }}</span> ”被第三人索赔的，用户同意全额补偿“ <span class="name">{{ name }}</span> ”（包括但不限于各种赔偿费用和律师费）；</li>
                    <li>d.当第三方认为用户上传或者发表于“ <span class="name">{{ name }}</span> ”的信息侵犯其权利，并根据《信息网络传播权保护条例》或者相关法律规定向“ <span class="name">{{ name }}</span> ”发送权利通知书时，用户同意“ <span class="name">{{ name }}</span> ”可以自行判断决定删除涉嫌侵权的用户上传或者发表于“ <span class="name">{{ name }}</span> ”的信息，除非收到符合相关法律规定且可以证明“ <span class="name">{{ name }}</span> ”不承担任何法律责任的书面说明，“ <span class="name">{{ name }}</span> ”将不会自动恢复上述删除的信息；</li>
                    <li>e.不得为任何非法目的而使用网络服务系统；</li>
                    <li>f.遵守所有与网络服务有关的网络协议、规定和程序；</li>
                    <li>g.不得利用“ <span class="name">{{ name }}</span> ”服务进行任何可能对互联网的正常运转造成不利影响的行为；</li>
                    <li>h.不得利用“ <span class="name">{{ name }}</span> ”服务进行任何不利于“ <span class="name">{{ name }}</span> ”的行为；</li>
                    <li>i.如发现任何非法使用用户帐号或帐号出现安全漏洞的情况，应立即通告“ <span class="name">{{ name }}</span> ”网站方。</li>
                    <li>j.如用户在使用网络服务时违反上述任何规定，“ <span class="name">{{ name }}</span> ”有权要求用户改正或直接采取一切必要的措施（包括但不限于删除用户张贴的内容、暂停或终止用户使用网络服务的权利）以减轻用户不当行为而造成的影响。</li>
                    <li>k.“ <span class="name">{{ name }}</span> ”将通过网站、软件等相关页面公布、更新、调整用户违规行为的相关标准，用户同意接受该等标准，共同保持健康的网络环境。用户不得发布低俗内容或进行违规表演，包括但不限于：
                        <ul>
                            <li>(1)衣冠不整、不文明、不雅观、不卫生等令普通人不能容忍的形象出现在公开视频；</li>
                            <li>(2)播放或使用粗俗的以及有违伦理道德的语言和行为、不雅的背景音乐或伴奏音乐；</li>
                            <li>(3)裸露全身或胸部、臀部、大腿内侧等不宜外露的部位；</li>
                            <li>(4)播放涉及淫秽色情内容的录像和视频，包括但不仅限于淫秽电影、色情动漫等；</li>
                            <li>(5)严禁主播或用户展示枪支刀具、进行高危表演。如晃动刀具、枪支、高仿真枪支、表演具有高度危险性的节目等；</li>
                            <li>(6)严禁主播或用户表演危害他人人身安全的节目。如：殴打他人、以枪支刀具威胁他人等；</li>
                            <li>(7)严禁主播或用户宣传传销机构、哄骗用户加入传销组织、或本人组织传销；</li>
                            <li>(8)严禁主播或用户表演危害自身安全的节目，如自杀、自残。</li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
     </div>
    <div>
    	<h2>四、内容权利</h2>
        <ul>
            <li>1.用户对于其创作并在“ <span class="name">{{ name }}</span> ”上发布的合法信息依法享有著作权及其相关权利。</li>
            <li>2.对于用户通过“ <span class="name">{{ name }}</span> ”网络服务上传到“ <span class="name">{{ name }}</span> ”的网络（包含网站、软件或移动终端等各类网络平台，以下同）上可公开获取区域的任何信息，用户同意“ <span class="name">{{ name }}</span> ”的运营公司及其关联公司在全世界范围内具有永久性的、不可撤销的权利和免许可费、可完全转授的权利。“ <span class="name">{{ name }}</span> ”运营公司及其关联公司可将用户通过“ <span class="name">{{ name }}</span> ”网络服务上传到网络上可公开获取区域的任何信息免费进行复制、修改、改编等以用“ <span class="name">{{ name }}</span> ”的业务，并可通过各种形式免费使用上述信息。</li>
            <li>3.用户向“ <span class="name">{{ name }}</span> ”作出的上述授权是独家的，即包括用户之表演和肖像权等合法权利在内，任何第三方未经“ <span class="name">{{ name }}</span> ”同意，不得将用户上传于“ <span class="name">{{ name }}</span> ”网络上的任何内容进行复制、修改、编辑、转让、使用或其他任何用途，包括但不限于截取视频信号、编辑视频/音频/文字和其他形式的网络内容等行为。用户同意向“<span class="name">{{ name }}</span> ”做出一项授权，授权“ <span class="name">{{ name }}</span> ”向第三方开展法律行动以维护用户与“ <span class="name">{{ name }}</span> ”的合法权益。</li>
		</ul>
      </div>
    <div>
    	<h2>五、隐私保护</h2>
        <ul>
            <li>1.用户同意个人隐私信息是指那些能够对用户进行个人辨识或涉及个人通信的信息，包括下列信息：用户的姓名，身份证号，手机号码，电子邮件地址信息。尊重用户个人隐私信息的私有性是“ <span class="name">{{ name }}</span> ”的一贯制度，“ <span class="name">{{ name }}</span> ”将会采取合理的措施保护用户的个人隐私信息，除法律或有法律赋予权限的政府部门要求或用户同意等原因外，“ <span class="name">{{ name }}</span> ”未经用户同意不向除合作单位以外的第三方公开、透露用户个人隐私信息。但是用户在注册时选择或同意，或用户与“ <span class="name">{{ name }}</span> ”及合作单位之间就用户个人隐私信息公开或使用另有约定的除外。同时为了运营和改善“ <span class="name">{{ name }}</span> ”的技术和服务，我们将可能会收集使用或向第三方提供用户的非个人隐私信息，这将有助于向用户提供更好的用户体验和提高我们的服务质量。</li>
            <li>2.	一般而言，“ <span class="name">{{ name }}</span> ”基于下列原因需要使用到用户的信息资源：
                <ul>
                    <li>a.执行服务所需的验证服务、升级服务；</li>
                    <li>b.为提高使用安全性等原因或提供客服支持；</li>
                    <li>c.提供服务公告或您感兴趣的信息，包括但不限于向您发出产品和服务通知；</li>
                    <li>d.将各种非个人隐私数据用于商业目的，包括但不限于向第三方提供增值服务、广告、定位广告、营销、联合注册其它服务、促销或其它任何活动（统称为“商业活动”）；</li>
                    <li>e.在用户参与抽奖、竞赛或类似推广活动时，将用户信息用于管理此类活动；</li>
                    <li>f.因用户使用“ <span class="name">{{ name }}</span> ”“ <span class="name">{{ name }}</span> ”特定功能或因用户要求“ <span class="name">{{ name }}</span> ”或合作单位提供特定服务时，“ <span class="name">{{ name }}</span> ”或合作单位则需要把用户的信息提供给与此相关联的第三方；</li>
                    <li>g.其他有利于用户的或有利于软件、网络服务功能改进的使用。</li>
                </ul>
            </li>
            <li>3.以下信息将不被认为是您的个人隐私信息：您在使用搜索服务时输入的关键字；其他无法进行个人辨识和不涉及个人通信的信息，例如用户对服务的操作状态以及使用习惯等一些反应客观情况的基本记录信息以及用户明确同意公开的隐私信息。</li>
            <li>4.<strong>“ <span class="name">{{ name }}</span> ”及其关联公司可互相分享用户信息，并按本隐私政策使用该信息。在不透露单个用户隐私资料的前提下，“ <span class="name">{{ name }}</span> ”有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</strong></li>
            <li>5.除非适用以下任意一种情况，或在本隐私权政策中已有规定，否则“ <span class="name">{{ name }}</span> ”不会向第三方公司、机构或个人披露用户信息：
                <ul>
                    <li>a.事先获得您的授权；</li>
                    <li>b.只有透露您的信息，才能提供您所要求的产品和服务；</li>
                    <li>c.根据有关的法律法规要求；</li>
                    <li>d.按照相关政府主管部门的要求；</li>
                    <li>e.为维护“ <span class="name">{{ name }}</span> ”及其关联公司的合法权益；</li>
                    <li>f.您违反了服务协议或相关规则，根据约定或相关规则规定可以披露您的信息；</li>
                    <li>g.我们需要向代表我们提供产品或服务的公司提供资料，但除非我们另行通知你，否则这些公司无权使用你的身份识别资料；</li>
                    <li>h.如您是适格的投诉人并已提起投诉，应被投诉人要求而向其披露您的信息，以便双方处理可能的权利纠纷。</li>
                    <li>i.其它“ <span class="name">{{ name }}</span> ”认为合适</li>
                </ul>
            </li>
        </ul>
     </div>
    <div>
    	<h2>六、免责声明</h2>
        <ul>
            <li>1.<strong>用户明确同意在其使用“ <span class="name">{{ name }}</span> ”服务时因其自身的行为所产生的风险将完全由其自己承担；因其使用“ <span class="name">{{ name }}</span> ”服务时采取的行为而产生的一切后果也由其自己承担，“ <span class="name">{{ name }}</span> ”对用户不承担任何责任。</strong></li>
            <li>2.“ <span class="name">{{ name }}</span> ”不保证服务一定能满足用户的要求，也不保证服务不会中断，对服务的及时性、安全性、准确性也都不作保证。</li>
            <li><strong>3.对于因不可抗力或“ <span class="name">{{ name }}</span> ”无法控制的第三方的原因造成的网络服务中断或其他缺陷，“ <span class="name">{{ name }}</span> ”不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</strong></li>
        </ul>
    </div>
    <div>
    	<h2>七、服务变更、中断或终止</h2>
        <ul>
            <li>1.如因系统维护或升级的需要而需暂停网络服务，“ <span class="name">{{ name }}</span> ”将尽可能事先在重要页面进行通告。/li>
            <li>2.<strong>如发生下列任何一种情形，“ <span class="name">{{ name }}</span> ”有权随时中断或终止向用户提供服务而无需通知用户：</strong>
<ul>
                <li>a.<strong>用户提供的个人资料不真实；</strong></li>
                    <li>b.<strong>用户违反本协议中规定的使用规则。</strong></li>
                    <li>c.<strong>用户在使用收费网络服务时未按规定向“ <span class="name">{{ name }}</span> ”支付相应的服务费。</strong></li>
                </ul>
            </li>
            <li>3.除前面所述情形外，<strong>“ <span class="name">{{ name }}</span> ”同时保留在事先通知用户的情况下随时中断或终止部分或全部服务的权利，对于所有服务的中断或终止而造成的任何损失，“ <span class="name">{{ name }}</span> ”无需对用户或任何第三方承担任何责任。</strong></li>
        </ul>
      </div>
    <div>
    	<h2>八、违约赔偿</h2>
        <ul>
            <li>1.用户同意保障和维护“ <span class="name">{{ name }}</span> ”及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款而给“ <span class="name">{{ name }}</span> ”或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。</li>
            <li>2.<strong>用户同意，在法律允许的情况下，因“ <span class="name">{{ name }}</span> ”违反本协议造成用户损失而需要向用户支付的任何、全部赔偿款的总额不应超过用户使用“ <span class="name">{{ name }}</span> ”支付的服务费。</strong></li>
        </ul>
    </div>
    <div>
    	 <h2>九、修改服务条款</h2>
        <ul>
            <li>1.“ <span class="name">{{ name }}</span> ”将可能随时修改本协议的有关条款，一旦条款内容发生变动，“ <span class="name">{{ name }}</span> ”将会在相关的页面提示修改内容。</li>
            <li>2.如果不同意“ <span class="name">{{ name }}</span> ”对服务条款所做的修改，用户有权停止使用“ <span class="name">{{ name }}</span> ”的服务。如果用户继续使用服务，则视为用户接受服务条款的变动。</li>
        </ul>
    </div>
    <div>
  		 <h2>十、法律管辖</h2>
        <ul>
            <li>1.本协议的订立、执行和解释及争议的解决均应适用中国大陆地区法律。</li>
            <li>2.如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；
                <ul>
                    <li><strong>协商不成时，任何一方均可向“ <span class="name">{{ name }}</span> ”运营公司所在地的人民法院提起诉讼。</strong></li>
                </ul>
            </li>
        </ul>
    </div>

    <div>
    	<h2>十一、通知和送达</h2>
        <ul>
            <li>1.本协议项下所有的通知均可通过重要页面公告、电子邮件或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。</li>
            <li>2.用户对于“ <span class="name">{{ name }}</span> ”的通知应当通过“ <span class="name">{{ name }}</span> ”对外正式公布的通信地址、电子邮件地址等联系信息进行送达。</li>
        </ul>
    </div>
    <div>
    	<h2>十二、其他规定</h2>
        <ul>
            <li>1.本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</li>
            <li>2.如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</li>
        </ul>
    </div>

</div>
</template>

<script>
export default {
  name: 'Provision',
  data () {
    return {
      name: '随风直播'
    }
  }
}
</script>

<style>

    body,ul,ol,li,p,h1,h2,h3,h4,h5,h6,form,label,dl,dt,dd,fieldset {margin:0;padding:0;}
    body {
        background-color: #FFF;
    }
    ul,ol,li {list-style:none;}
    table{border-collapse:collapse;border-spacing:0;}
    img {border:none;}
    input,img,select {vertical-align:middle;}
    body,fieldset,th,td,select,input,textarea {font-family:"微软雅黑",Arial,Helvetica,sans-serif; color:#666;}
    select,input {vertical-align:middle;}
    cite,em {font-style:normal;}
    .wordwrap {word-wrap:break-word;word-break:break-all;}

    a:link,a:visited,a:hover,a:active {text-decoration:none;}
    .text_box{ padding:20px;}
    .text_box div{ color:#000; line-height:24px;}
    .text_box h2{ font-size:16px;}
    
</style>
